"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleValues = exports.RolesEnum = void 0;
// BACKFILL
var RolesEnum;
(function (RolesEnum) {
    RolesEnum["SUPER_USER"] = "SUPER_USER";
    RolesEnum["OWNER"] = "OWNER";
    RolesEnum["ADMIN"] = "ADMIN";
    RolesEnum["BOX_OFFICE"] = "BOX_OFFICE";
    RolesEnum["SCANNER"] = "SCANNER";
    RolesEnum["USER"] = "USER";
})(RolesEnum = exports.RolesEnum || (exports.RolesEnum = {}));
exports.roleValues = {
    [RolesEnum.SUPER_USER]: 5,
    [RolesEnum.OWNER]: 4,
    [RolesEnum.ADMIN]: 3,
    [RolesEnum.BOX_OFFICE]: 2,
    [RolesEnum.SCANNER]: 1,
    [RolesEnum.USER]: 0,
};
// export enum RoleOrdinalEnum {
//   SCANNER = 0,
//   BOX_OFFICE,
//   ADMIN,
//   OWNER,
//   SUPER_USER,
// }
//# sourceMappingURL=IRole.js.map